import { cn } from "@/lib/utils";

/**
 * Brand loader: three transcript lines writing themselves in sequence —
 * speech becoming text. For full-stage loading states (route transitions,
 * page-level fetches); inline spots keep the plain Spinner.
 */
export const TranscribeLoader = ({ className }: { className?: string }) => (
  <div className={cn("flex w-14 flex-col gap-2", className)} role="status" aria-label="Loading">
    {["w-full", "w-3/4", "w-1/2"].map((width, i) => (
      <div
        key={width}
        className={cn(
          "h-1.5 origin-left animate-transcribe-line rounded-full bg-muted-foreground/50 motion-reduce:animate-pulse",
          width
        )}
        style={{ animationDelay: `${i * 180}ms` }}
      />
    ))}
  </div>
);

export const LoadingScreen = ({ className, text = "" }: { className?: string; text?: string }) => {
  return (
    <div
      className={cn(
        "flex min-h-[50vh] w-full flex-col items-center justify-center gap-4",
        className
      )}
    >
      <TranscribeLoader />
      {text && <p className="text-muted-foreground">{text}</p>}
    </div>
  );
};
